// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"dd2511d3","453":"68d2f560","732":"30edfecb"}[chunkId] + ".chunk.js";
};